import { ensureConfig, getConfig } from "@edx/frontend-platform";
import { getAuthenticatedHttpClient } from "@edx/frontend-platform/auth";
import { AppContext } from "@edx/frontend-platform/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import facebook from "../assets/images/facebook.png";
import FooterLogo from "../assets/images/openedx.png";
import instagram from "../assets/images/instagram.png";
import linkedin from "../assets/images/linkedin.png";
import twitter from "../assets/images/twitter.png";
import youtube from "../assets/images/youtube.png";

ensureConfig(
  [
    "LMS_BASE_URL",
    "LOGOUT_URL",
    "LOGIN_URL",
    "SITE_NAME",
    "LOGO_URL",
    "ORDER_HISTORY_URL",
  ],
  "Header component"
);

const Footer = () => {
  const { authenticatedUser, config } = useContext(AppContext);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [profileImage, setProfileImage] = useState(
    `${getConfig().LMS_BASE_URL}/static/images/profiles/default_50.png`
  );
  const [link, setlink] = useState("#");

  /*  Tawk.to Script  */
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = 'https://embed.tawk.to/5d2ebe5d9b94cd38bbe7bfc3/default';
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(script, firstScript);

    return () => {
      // Cleanup the script if the component is unmounted
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (authenticatedUser) {
        try {
          console.log(`Fetching profile for user: ${config.LMS_BASE_URL}`);
          const url = `${getConfig().LMS_BASE_URL}/api/user/v1/accounts/${
            authenticatedUser?.username && authenticatedUser?.username
          }`;
          const response = await getAuthenticatedHttpClient().get(url);

          setProfileImage(response?.data?.profile_image?.image_url_small);
        } catch (error) {
          console.error("Error fetching user profile:", error);
        }
      }
    };

    fetchUserProfile();
  }, [authenticatedUser, config.LMS_BASE_URL]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
  };

  function getCookie(cookieName) {
    try {
      const cookies = document.cookie.split(';');
      for (const cookie of cookies) {
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) {
          const decodedValue = decodeURIComponent(value);
          return decodedValue;
        }
      }
      return null;
    } catch (error) {
      console.error('Error reading cookie:', error);
      return null;
    }
  }

  function getResumeBlockFromCookie() {
    try {
      const edxUserInfo = getCookie('edx-user-info');
      if (!edxUserInfo) {
        return "" || "#";
      }
      const cleanedInfo = edxUserInfo?.replace(/\\"/g, '"').replace(/^"|"$/g, '') || '';
      const resumeBlockMatch = cleanedInfo?.match(/resume_block\"\s*:\s*\"([^\"]+)\"/) || [];
      if (resumeBlockMatch && resumeBlockMatch[1]) {
        const resumeBlockUrl = resumeBlockMatch[1] || '';
        return resumeBlockUrl;
      }
      return null;
    } catch (error) {
      console.error('Error extracting resume block:', error);
      return null;
    }
  }

  useEffect(() => {
    const resumeBlockUrl = getResumeBlockFromCookie();
    setlink(resumeBlockUrl || '#');
  }, []);

  return (
    <>
      {/* <main className="main">{children}</main> */}

      <footer className="footer">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center">
            <div className="left-footer">
              <img src={FooterLogo} alt="Footer Logo" />
            </div>
            <div className="middle-footer">
              <ul>
                <li>© IIMBx. All rights reserved except where noted.</li>
                <li>
                  <a
                    className="dropdown-item"
                    href="https://iimbx.iimb.ac.in/privacy/"
                  >
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="https://iimbx.iimb.ac.in/tos/"
                  >
                    Terms of Service
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="https://iimbx.iimb.ac.in/honor/"
                  >
                    Honor Code
                  </a>
                </li>
              </ul>
            </div>
            <div className="right-footer">
              <ul className="social-media">
                <li>
                  <a href="https://www.facebook.com/iimbxonline/">
                    <img src={facebook} alt="Facebook" />
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com/iimbxonline">
                    <img src={twitter} alt="Twitter" />
                  </a>
                </li>
                <li>
                  <a href="https://in.linkedin.com/company/iimbxonline">
                    <img src={linkedin} alt="LinkedIn" />
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/iimbxonline">
                    <img src={youtube} alt="YouTube" />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/iimbxonline/">
                    <img src={instagram} alt="Instagram" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
